<template>
  <div class="image-uploader">
    <div
        class="upload-click-wrap"
        :class="{ 'has-image': !!finalPreview }"
        @click="triggerUpload"
        role="button"
    >
      <!-- Thumbnail -->
      <img
          v-if="finalPreview"
          :src="finalPreview"
          class="upload-img"
          :alt="altText"
      />

      <!-- Placeholder -->
      <div v-else class="upload-placeholder">
        <i class="el-icon-plus"></i>
        <span>{{ placeholder }}</span>
      </div>

      <!-- Preview button -->
      <button
          v-if="finalPreview"
          class="preview-btn"
          @click.stop="openPreview"
          type="button"
      >
        <i class="el-icon-view"></i>
      </button>

      <!-- Remove -->
<!--      <button-->
<!--          :disabled="!updateAttendance"-->
<!--          v-if="finalPreview && removable && updateAttendance"-->
<!--          class="remove-btn"-->
<!--          @click.stop="handleRemove"-->
<!--          type="button"-->
<!--      >-->
<!--        <i class="el-icon-circle-close"></i>-->
<!--      </button>-->

      <!-- Hidden uploader -->
      <el-upload
          :disabled="!updateAttendance"
          ref="uploader"
          class="hidden-upload"
          :show-file-list="false"
          :on-change="handleChange"
          :auto-upload="false"
          :limit="1"
          accept="image/jpeg,image/png"
      />
    </div>

    <!-- Full preview -->
    <el-dialog
        :visible.sync="previewDialogVisible"
        width="900px"
        append-to-body
        class="image-preview-dialog"
    >
      <div class="preview-scroll-container">
        <img :src="finalPreview" class="full-preview-image"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ImageUploader",
  props: {
    value: { // Đây là prop cho v-model
      type: File,
      default: null
    },
    preview: String,
    placeholder: { type: String, default: "Tải ảnh" },
    altText: { type: String, default: "Ảnh" },
    removable: { type: Boolean, default: true },
    maxSize: { type: Number, default: 5 },
    updateAttendance: { type: Boolean, default: false },
  },
  data() {
    return {
      localFile: null,
      localPreview: null,
      previewDialogVisible: false
    };
  },
  computed: {
    finalPreview() {
      if (this.localPreview) return this.localPreview;
      return this.preview || null;
    }
  },
  watch: {
    // Khi prop value (từ v-model) thay đổi từ bên ngoài → cập nhật local
    value(newVal) {
      if (!newVal) {
        this.localFile = null;
        this.localPreview = null;
      }
    }
  },
  methods: {
    triggerUpload() {
      // Nếu disabled → không làm gì
      if (!this.updateAttendance) return;

      const uploader = this.$refs.uploader;
      if (!uploader) return;
      const input = uploader.$el.querySelector("input[type=file]");
      if (input) {
        input.value = null;
        input.click();
      }
    },
    handleChange(file) {
      if (!file || !file.raw) return;

      const raw = file.raw;

      if (!this.validateFile(raw)) {
        this.clearUploader();
        return;
      }

      // Revoke preview cũ
      if (this.localPreview?.startsWith("blob:")) {
        URL.revokeObjectURL(this.localPreview);
      }

      // Cập nhật local
      this.localPreview = URL.createObjectURL(raw);
      this.localFile = raw;

      // QUAN TRỌNG: Emit "input" với file mới → v-model sẽ cập nhật shift.checkinImage
      this.$emit("input", raw);

      this.clearUploader();
    },

    clearUploader() {
      try {
        this.$refs.uploader?.clearFiles();
      } catch (e) {
        console.log(e);
      }
    },

    validateFile(file) {
      const validType = ["image/jpeg", "image/png"].includes(file.type);
      const validSize = file.size / 1024 / 1024 <= this.maxSize;

      if (!validType) {
        this.$message.error("Chỉ chấp nhận ảnh JPG hoặc PNG");
        return false;
      }
      if (!validSize) {
        this.$message.error(`Ảnh không vượt quá ${this.maxSize}MB`);
        return false;
      }
      return true;
    },

    openPreview() {
      if (this.finalPreview) {
        this.previewDialogVisible = true;
      }
    },

    handleRemove() {
      if (this.updateAttendance) return;

      if (this.localPreview?.startsWith("blob:")) {
        URL.revokeObjectURL(this.localPreview);
      }

      this.localPreview = null;
      this.localFile = null;
      this.$emit("input", null);
      this.clearUploader();
    }
  }
};
</script>

<style scoped>
.image-uploader {
  display: inline-block;
}

.upload-click-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  border: 1px dashed #cfcfcf;
  border-radius: 10px;
  background: #fafafa;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-click-wrap:hover {
  transform: translateY(-4px) scale(1.02);
  border-color: #4da3ff;
  box-shadow: 0 8px 20px rgba(29, 89, 153, 0.06);
  background: #f0f8ff;
}

.upload-click-wrap.has-image {
  border: none;
  background: transparent;
}

.upload-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.upload-placeholder {
  text-align: center;
  color: #7b93bf;
  font-size: 14px;
}

.upload-placeholder i {
  font-size: 28px;
  display: block;
  margin-bottom: 8px;
}

.preview-btn,
.remove-btn {
  position: absolute;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

.preview-btn {
  top: 6px;
  right: 6px;
  color: #3b82f6;
}

.remove-btn {
  top: 6px;
  left: 6px;
  color: #d9534f;
}

.hidden-upload ::v-deep .el-upload {
  display: none !important;
}

.full-preview-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

/* Dialog preview ảnh lớn - kích thước cố định */
.image-preview-dialog ::v-deep .el-dialog {
  width: 900px !important;
  height: 80vh !important;
  margin-top: 5vh !important;
  background: rgba(0, 0, 0, 0.95);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.image-preview-dialog ::v-deep .el-dialog__header {
  padding: 0;
  flex: none;
}

.image-preview-dialog ::v-deep .el-dialog__headerbtn {
  top: 15px;
  right: 15px;
  font-size: 28px;
  color: white;
  z-index: 10;
}

/* Body chiếm toàn bộ không gian còn lại */
.image-preview-dialog ::v-deep .el-dialog__body {
  padding: 0;
  flex: 1;
  overflow: hidden; /* Ẩn scroll mặc định */
}

/* Container chính - hỗ trợ scroll khi ảnh quá lớn */
.preview-scroll-container {
  width: 100%;
  height: 100%;
  overflow: auto; /* Hiện thanh cuộn khi cần */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px; /* Khoảng cách nhẹ để ảnh không sát viền */
  box-sizing: border-box;
}

/* Ảnh preview lớn */
.full-preview-image {
  max-width: 100%;
  max-height: 100%; /* Quan trọng: cho phép ảnh cao hơn nếu cần scroll */
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
  background: black; /* Nền đen khi ảnh trong suốt */
}

/* Thanh cuộn đẹp hơn (Webkit browsers) */
.preview-scroll-container::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.preview-scroll-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
}

.preview-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 6px;
}

.preview-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* Hỗ trợ Firefox */
.preview-scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) rgba(255, 255, 255, 0.1);
}
</style>